package fr.frux.core.common.io

import fr.frux.core.common.logging.Logger
import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

private const val TAG = "FileExporter"

/**
 * Blob + ancre `download` : le mécanisme standard côté navigateur, sans dépendance externe.
 * L'URL objet est révoquée juste après le clic simulé — elle n'a besoin de vivre que le temps
 * que le navigateur déclenche le téléchargement.
 */
private object JsFileExporter : FileExporter {
    override suspend fun export(fileName: String, content: String): Boolean {
        return try {
            val blob = Blob(arrayOf(content), BlobPropertyBag(type = "application/json"))
            val url = URL.createObjectURL(blob)
            val anchor = document.createElement("a") as HTMLAnchorElement
            anchor.href = url
            anchor.setAttribute("download", fileName)
            anchor.style.display = "none"
            document.body?.appendChild(anchor)
            anchor.click()
            anchor.remove()
            URL.revokeObjectURL(url)
            true
        } catch (e: Exception) {
            Logger.e(TAG, "Échec du téléchargement de fichier ($fileName)", e)
            false
        }
    }
}

actual fun createFileExporter(): FileExporter = JsFileExporter
